import { Component, OnInit, ChangeDetectorRef, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { CadastroService } from '../../../services/cadastro.service';
import { ControleProducaoDetalhado } from '../../../models/cadastro.model';
import { ErrorModel } from '../../../models/error.model';
import { Router } from '@angular/router';
import { FinanceiroService } from '../../../services/financeiro.service';

@Component({
  selector: 'app-controle-producao',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './controle-producao.component.html',
  styles: []
})
export class ControleProducaoComponent implements OnInit {
  controles: ControleProducaoDetalhado[] = [];
  filteredControles: ControleProducaoDetalhado[] = [];
  paginatedControles: ControleProducaoDetalhado[] = [];

  currentPage = 1;
  itemsPerPage = 10;
  totalPages = 1;

  maxPagesToShow = 5;
  startPage = 1;
  endPage = 1;
  pages: number[] = [];

  searchTerm = '';

  private cdr = inject(ChangeDetectorRef);

  constructor(
    private cadastroService: CadastroService,
    private financeiroService: FinanceiroService,
    private router: Router,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.loadControles();
  }

  loadControles(): void {
    this.cadastroService.getControlesProducaoDetalhado().subscribe({
      next: (data) => {
        this.controles = data;
        this.filteredControles = data;
        this.totalPages = Math.max(1, Math.ceil(this.filteredControles.length / this.itemsPerPage));
        this.setPage(1);
        this.cdr.detectChanges();
      },
      error: (error) => {
        const erro: ErrorModel = error.error;
        this.toastr.error(erro?.message || 'Erro ao carregar serviços em produção.');
      }
    });
  }

  search(): void {
    const term = this.searchTerm.trim();

    if (!term) {
      this.filteredControles = [...this.controles];
      this.totalPages = Math.max(1, Math.ceil(this.filteredControles.length / this.itemsPerPage));
      this.setPage(1);
      return;
    }

    this.financeiroService.getContasAReceberPorCliente(term, 0, 100).subscribe({
      next: (response) => {
        const vendasEncontradas = new Set(
          response.content
            .map(conta => conta.venda?.id)
            .filter((id): id is number => Number.isFinite(id))
        );

        this.filteredControles = this.controles.filter(controle => vendasEncontradas.has(controle.idVenda));
        this.totalPages = Math.max(1, Math.ceil(this.filteredControles.length / this.itemsPerPage));
        this.setPage(1);

        if (!this.filteredControles.length) {
          this.toastr.warning('Nenhum serviço em produção encontrado para o cliente informado.');
        }
      },
      error: (error) => {
        const erro: ErrorModel = error.error;
        this.toastr.error(erro?.message || 'Erro ao buscar serviços em produção por cliente.');
      }
    });
  }

  setPage(page: number): void {
    if (page < 1 || page > this.totalPages) {
      return;
    }

    this.currentPage = page;
    const startIndex = (page - 1) * this.itemsPerPage;
    const endIndex = Math.min(startIndex + this.itemsPerPage, this.filteredControles.length);
    this.paginatedControles = this.filteredControles.slice(startIndex, endIndex);
    this.updatePageNumbers();
  }

  updatePageNumbers(): void {
    const halfPages = Math.floor(this.maxPagesToShow / 2);
    this.startPage = Math.max(1, this.currentPage - halfPages);
    this.endPage = Math.min(this.totalPages, this.startPage + this.maxPagesToShow - 1);

    if (this.endPage - this.startPage + 1 < this.maxPagesToShow) {
      this.startPage = Math.max(1, this.endPage - this.maxPagesToShow + 1);
    }

    this.pages = Array.from({ length: (this.endPage - this.startPage) + 1 }, (_, i) => this.startPage + i);
  }

  verDetalhes(idControle: number): void {
    this.router.navigate(['/home', 'producao-controle-manutencao', idControle]);
  }
}